import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { NewsletterService } from '../../../services/newsletter.service';

@Component({
  selector: 'app-main-newsletter',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './main-newsletter.component.html',
  styleUrl: './main-newsletter.component.scss'
})
export class MainNewsletterComponent {
  ImagePath: any;
  currentImagePath: string = '';
  constructor(private NewsletterService: NewsletterService,
      private router: Router,private activatedRoute: ActivatedRoute) { }

      ngOnInit() {
    const imagePath = localStorage.getItem('selectedImage');
    if (imagePath) {
      this.currentImagePath = imagePath;
    } else {
      console.error('No image found in localStorage');
    }

    this.router.events.pipe(
          filter((event: any) => event instanceof NavigationEnd),
          map(() => this.activatedRoute),
          map((route) => {
            while (route.firstChild) route = route.firstChild;
            return route;
          }),
          filter((route) => route.outlet === 'primary'),
          mergeMap((route: { data: any; }) => route.data)
        )
  }

     goHome() {
    this.router.navigate(['/']);
  }

  goNewsLetter(){
    this.router.navigate(['/news-letters/newsletter']);
  }
}